import { render, staticRenderFns } from "./MachineSitesFormPage2.vue?vue&type=template&id=808de72c&scoped=true&"
import script from "./MachineSitesFormPage2.vue?vue&type=script&lang=js&"
export * from "./MachineSitesFormPage2.vue?vue&type=script&lang=js&"
import style0 from "./MachineSitesFormPage2.vue?vue&type=style&index=0&id=808de72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808de72c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VIcon,VRow})
